import {range} from 'lodash';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import Slider from 'react-slick';
import {isChatConnection, isMeetingConnection} from '../../../data/filters/connectionsFilters';
import { useEventConnections } from '../../../data/hooks/connections/useEventConnections';
import {useI18n} from '../../../data/hooks/i18nHooks';
import {useMutualFavorites} from '../../../data/hooks/participant/useMutualFavorites';
import ConnectionBetweenUsersHeader from '../ConnectionBetweenUsersHeader/ConnectionBetweenUsersHeader';
import styles from './MutualFavoritesHeader.module.scss';
import SayHello from './SayHello/SayHello';

function MutualFavoritesHeader(props) {
    const {eventId, baseRoute = '.'} = props,
        connections = useEventConnections(eventId, {filter: c => isChatConnection(c) || isMeetingConnection(c)}),
        filterOutExistingConnections = useCallback(participant => !connections.find(connection => connection.id == participant.id), [connections]),
        mutual = useMutualFavorites(eventId, {
            filter: filterOutExistingConnections,
            sortBy: 'date_favorite_updated_utc',
            count: 10,
        }).reverse(),
        [currentSlide, setCurrentSlide] = useState(0),
        user = mutual[currentSlide],
        ref = useRef(),
        sliderRef = useRef(),
        i18n = useI18n(),
        [width, setWidth] = useState(600);

    useEffect(() => {
        setWidth(ref.current.offsetWidth);
    });

    const handleSlideChanged = useCallback(slide => {
            setCurrentSlide(slide);
        }, []),
        handleStartNetworking = useCallback(() => {
            app.history.push(['/events', eventId, 'start-networking'].join('/'));
        }, [eventId]),
        handleJumpToSlide = useCallback(
            index => {
                sliderRef.current.slickGoTo(index % (mutual.length + 1));
            },
            [mutual]
        ),
        handleArrowClicked = useCallback(() => {
            if (currentSlide < mutual.length) {
                handleJumpToSlide(currentSlide + 1);
            } else {
                handleJumpToSlide(0);
            }
        }, [currentSlide, mutual, handleStartNetworking, handleJumpToSlide]);

    return (
        <div className={styles.MutualFavoritesHeader}>
            <h2 className={user ? '' : styles.hidden}>{i18n['doubleFavo.title']}</h2>
            <div ref={ref} className={styles.connections}>
                <ConnectionBetweenUsersHeader
                    className={[styles.header, width < 380 ? styles.smaller : ''].join(' ')}
                    eventId={eventId}
                    stretched={!!user}
                    left={{self: true}}
                    arrow={mutual.length}
                    right={{
                        user,
                        startNetworking: !user,
                    }}
                    baseRoute={baseRoute}
                    onArrowClick={handleArrowClicked}>
                    {user ? <SayHello eventId={eventId} user={user} baseRoute={baseRoute} /> : null}
                </ConnectionBetweenUsersHeader>
            </div>
            {mutual.length ? (
                <div className={styles.slides}>
                    <Slider
                        ref={slider => (sliderRef.current = slider)}
                        dots={true}
                        slidesToShow={1}
                        touchMove={true}
                        infinite={false}
                        cssEase="ease-out"
                        afterChange={handleSlideChanged}>
                        {range(0, mutual.length + 1).map(index => (
                            <div key={index}></div>
                        ))}
                    </Slider>
                </div>
            ) : null}
        </div>
    );
}

export default MutualFavoritesHeader;
